import React, { useEffect } from 'react'
import { Accordion, AccordionDetails, AccordionSummary, Box, Grid, Typography, Tabs, Tab } from '@mui/material'
import services from '../constants/services.json'
import BreakLiner from '../utils/BreakLiner'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Paper from '@mui/material/Paper';
import useNavActive from '../utils/ScrollHook';
import RequestService from './RequestService';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      id={services[index].id}
      aria-labelledby={`services-tab-${index}`}
      {...other}
    >
      {/*
      hidden={value !== index}
      value === index &&
      */}
      { (
        <Grid container
          alignItems="center"
          alignContent="center"
          sx={{ px: 2, py:4 }}
          spacing={{ xs: 2, md: 3, lg: 8 }}
          rowGap="2em"
          minHeight='calc(100vh - 4em)'
        >
          {children}
        </Grid>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `services-tab-${index}`,
    'aria-controls': services[index].id,
    href: `#${services[index].id}`
  };
}


function Services() {
  // const [serviceIdx, setServiceIdx] = React.useState(0)
  // const handleChange = (event: React.SyntheticEvent, newValue: number) => {
  //   setServiceIdx(newValue);
  // };
  const currNav = useNavActive( services.map( p => p.id ) );
  
  const tabCheckOr = ()=> window.innerWidth > 900 ? "vertical" : "horizontal"
  const [tabOrientation, setTabOrientation] = React.useState<"vertical"|"horizontal">(tabCheckOr)
  useEffect(()=>{
    window.addEventListener('resize', ()=>setTabOrientation(tabCheckOr));
    return () => window.removeEventListener('resize', ()=>setTabOrientation(tabCheckOr));
  }, [window])

  return (
    <Box
      component="section"
      id="services"
      className='gl'
      sx={{mx: -2, pt: 12, borderTop:1, borderColor: 'divider'}}
    >

      <Typography variant="h2" textAlign="center" gutterBottom>
        Nuestros servicios
      </Typography>

      <Grid container
        alignItems="flex-start"
        sx={{ py: 4 }}
      >

        <Grid item
          xs={12} md={2}
          position="sticky"
          top={tabOrientation==="vertical"?'calc(50% - 10em)':"0px"}
          sx={{zIndex:8}}
        >
          <Paper elevation={0}
          sx={tabOrientation==="vertical"?{backgroundColor:"transparent"}:{}}
          >
            <Tabs
              orientation={tabOrientation}
              variant="scrollable"
              value={currNav}
              // onChange={handleChange}
              aria-label="Lista de Servicios"
              sx={tabOrientation==="vertical"?{ borderRight: 1, borderColor: 'divider' }:{}}
            >
              {services.map( (s, i) =>
              <Tab key={i} label={s.title} {...a11yProps(i)} />
              )}
            </Tabs>
          </Paper>
        </Grid>

        <Grid item xs={12} md={10}>
          {services.map( (s, i) =>
          <TabPanel key={i} value={currNav} index={i}>
            <Grid item
              xs={12} md={6}
              display="flex"
              flexDirection="column"
              justifyContent="center"
              rowGap={2}
              order={ tabOrientation==="vertical" ? i%2 === 0 ? 1 : 2 : 2 }
            >
              <Typography variant='h4'>{s.title}</Typography>
              <BreakLiner text={s.description} className="description" variant='body1'/>  
              {s.subservices ?
              <Box sx={{mt: 2}}>
                {s.subservices.map( ss => (
                <Accordion key={ss.title} elevation={0} sx={{backgroundColor:'transparent'}}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography variant='h6'>{ss.title}</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <BreakLiner text={ss.description} className="description" variant='body2'/>
                  </AccordionDetails>
                </Accordion>
                ))}
              </Box>
              : ''}
              {/* <Button variant='contained'>Solicitar</Button> */}
              <RequestService service={s.title}/>
            </Grid>
            <Grid item
              xs={12} md={6}
              height="20rem"
              order={ tabOrientation==="vertical"? i%2 === 0 ? 2 : 1 : 1 }
            >
              <img src={`images/sections/${s.image}`} alt={s.title} className="fill"/>
            </Grid>
          </TabPanel>
          )}
        </Grid>

      </Grid>

    </Box>

  )
}

export default Services